module.exports = __webpack_public_path__ + "static/media/foul-play-feature-banner-md@1x.3c3461ce.jpg";